import React from 'react'
import "./pageBlog.css";

import HeaderBlog4 from "../pageBlog/HeaderBlog4";
 import BodyBlog4 from "../pageBlog/BodyBlog4";
import Footer2 from "../footer2/Footer2";

function PageBlog4() {
  return (
    <section>
      
       <HeaderBlog4/>
       <BodyBlog4/>
       <Footer2/>
    </section>
  )
}

export default PageBlog4